<template>
  <div class="chladni-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>二维驻波与节线</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 240 240" class="centered-svg">
          <!-- The Vibrating Plate -->
          <rect x="20" y="20" width="200" height="200" fill="rgba(80,80,80,0.2)" stroke="#888" />
          
          <!-- The Node Lines (The pattern) -->
          <g v-if="freq === 1">
             <line x1="120" y1="20" x2="120" y2="220" stroke="#fff" stroke-width="2" />
             <line x1="20" y1="120" x2="220" y2="120" stroke="#fff" stroke-width="2" />
          </g>
          <g v-else-if="freq === 2">
             <circle cx="120" cy="120" r="70" fill="none" stroke="#fff" stroke-width="2" />
          </g>
          <g v-else-if="freq === 3">
             <path d="M 120,20 Q 150,120 120,220 M 20,120 Q 120,150 220,120" fill="none" stroke="#fff" stroke-width="2" />
             <path d="M 120,20 Q 90,120 120,220 M 20,120 Q 120,90 220,120" fill="none" stroke="#fff" stroke-width="2" />
          </g>

          <!-- Randomized sand particles near nodes -->
          <circle v-for="n in 100" :key="n" :cx="calcSandX(n)" :cy="calcSandY(n)" r="1.2" fill="#ffd700" opacity="0.6">
             <animate attributeName="opacity" values="0.4;0.8;0.4" dur="0.2s" repeatCount="indefinite" />
          </circle>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>激发频率 f: {{ freq }} 阶模态</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-radio-group v-model="freq" size="mini">
                <el-radio :label="1">低频模态</el-radio>
                <el-radio :label="2">环形模态</el-radio>
                <el-radio :label="3">复杂高阶模态</el-radio>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当薄板受高频振动激发时，板面上某些区域振动剧烈（波腹），而另一些区域保持静止（节线）。撒在板上的沙子会被弹射到振动微弱的节线处堆积，从而显现出规则而精美的**克拉尼图形**。这些图形直观地展示了二维结构中复杂驻波的分布形态，对乐器声学和结构工程至关重要。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChladniPatternsViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      freq: 1
    }
  },
  methods: {
    calcSandX(n) {
       // Mock distribution near node lines
       if (this.freq === 1) return Math.random() > 0.5 ? (120 + (Math.random()-0.5)*10) : (20 + Math.random()*200);
       if (this.freq === 2) return 120 + 70 * Math.cos(n * 0.06);
       return 120 + (Math.random()-0.5)*150;
    },
    calcSandY(n) {
       if (this.freq === 1) return this.calcSandX(n+1) === (120 + (Math.random()-0.5)*10) ? (20 + Math.random()*200) : (120 + (Math.random()-0.5)*10);
       if (this.freq === 2) return 120 + 70 * Math.sin(n * 0.06);
       return 120 + (Math.random()-0.5)*150;
    }
  }
}
</script>

<style scoped lang="scss">
.chladni-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.centered-svg { display: block; margin: 0 auto; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
